export enum MatchAlgorithm {
  Equals = 0,
  Includes
}
